import { render, staticRenderFns } from "./CustomerFetchList.vue?vue&type=template&id=22638099&scoped=true"
import script from "./CustomerFetchList.vue?vue&type=script&lang=js"
export * from "./CustomerFetchList.vue?vue&type=script&lang=js"
import style0 from "./CustomerFetchList.vue?vue&type=style&index=0&id=22638099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22638099",
  null
  
)

export default component.exports